import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import i18n from '@/i18n';
import { DagRunDto } from '@/api';
import SChipBasic from '@/components/SChipBasic.vue';
import type { SiffletColors } from '@/plugins/theme';

interface OrchestrationStatusProps {
  lastExecutionDate?: number;
  lastRunState?: DagRunDto.state,
}

interface StatusPresentation {
  icon: string;
  color: SiffletColors;
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Orchestration-Status',
  props: {
  lastExecutionDate: null,
  lastRunState: null
},
  setup(__props) {

const props = __props;



const status = computed<StatusPresentation>(() => {
  switch (props.lastRunState) {
    case DagRunDto.state.SUCCESS:
      return {
        icon: 'icon-check',
        color: 'iconSuccess',
        text: i18n.tc('common.words.success'),
      };
    case DagRunDto.state.FAILED:
      return {
        icon: 'icon-error-circle-outline',
        color: 'iconDanger',
        text: i18n.tc('common.words.broken'),
      };
    case DagRunDto.state.QUEUED:
      return {
        icon: 'icon-arrow-right',
        color: 'iconWarning',
        text: i18n.tc('common.words.queued'),
      };
    case DagRunDto.state.RUNNING:
      return {
        icon: 'icon-arrow-sync',
        color: 'iconSuccess',
        text: i18n.tc('common.words.running'),
      };
    default:
      return {
        icon: 'icon-question-circle-outline',
        color: 'iconNeutral',
        text: i18n.tc('common.words.unknown'),
      };
  }
});

return { __sfc: true,props, status, computed, i18n, DagRunDto, SChipBasic }
}

})